import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Text,
  useToast
} from "@chakra-ui/react";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import TrTheoryAnswers from "../../../../components/trainer/courses/assignments/TheoryAnswers";

export default function TrTheory() {
  const navigate = useNavigate();
  const location = useLocation();
  const { title } = location.state || {};
  const toast = useToast();
  const [ass_name, setAssname] = useState("");

  useEffect(() => {
    const question_header = localStorage.getItem("naptin_assignment");
    if (question_header) {
      setAssname(JSON.parse(question_header).title);
    }
  }, []);

  const params = useParams();
  const course_id: any = params.course_id;

  const sendAssgnment = () => {
    localStorage.removeItem("naptin_assignment");
    navigate(`/trainer/course/${course_id}/assignments`);
    toast({
      title: "Assignment",
      description: "Assignment sent to trainees",
      status: "success",
    });
  };
  return (
    <Box minHeight="100vh" bg="#F9F8F8">
      <Box position="fixed" zIndex="1" width="100%">
        <Box>
          <Flex
            px={12}
            height="70px"
            bg="#FFFFFF"
            color="#616161"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box mx={"auto"} my="auto">
              <Text
                pt="15px"
                color="#959595"
                fontWeight={"600"}
                bg="white"
                fontSize={"24px"}
                mr="20px"
                width="100%"
                textTransform={"capitalize"}
                height="70px"
              >
                {title}
              </Text>
            </Box>
            <HStack spacing={6}>
              <Button
                pb="50px"
                px="30px"
                mt="30px"
                fontSize={16}
                variant="unstyled"
                onClick={() => {
                  navigate(-1);
                }}
                colorScheme="red"
                size="md"
              >
                Exit
              </Button>
            </HStack>
          </Flex>
        </Box>
      </Box>

      <Container
        width={"80%"}
        maxWidth={"94%"}
        px={0}
        pt="100px"
        right={0}
        bg="F9F8F8"
        mx="auto"
      >
        <Box bg="white">
          <TrTheoryAnswers />
        </Box>
      </Container>
    </Box>
  );
}
